import Vue from 'vue'
import App from './App.vue'
import router from './router/'
import store from './store/'
import vuetify from './plugins/vuetify'
import cssVars from 'css-vars-ponyfill'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-free/css/all.css'
import './plugins/axios'
import './plugins/appMessages'
import './plugins/googleMaps'
import './assets/scss/app.scss'
import './plugins/filters'

/**
 * Layouts
 */
import AppLayout from './layouts/AppLayout.vue'
import AuthLayout from './layouts/AuthLayout.vue'
import EmptyLayout from './layouts/EmptyLayout.vue'
Vue.component('app-layout', AppLayout)
Vue.component('auth-layout', AuthLayout)
Vue.component('empty-layout', EmptyLayout)

/**
 * Global Components
 */
import { FsCard, DataTableCard } from '@/components/partials/'
import { ValuationPreviewCard } from '@/components/valuation'
import { AdvertisingTransactions } from '@/components/report/'
Vue.component('fs-card', FsCard)
Vue.component('valuation-preview-card', ValuationPreviewCard)
Vue.component('data-table-card', DataTableCard)
Vue.component('advertising-transactions', AdvertisingTransactions)

Vue.config.productionTip = false

cssVars({
  rootElement: document,
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
